<template>
  <div class="dsf_special_detail" :style="{ display: visible ? 'block' : 'none' }">
    <div class="special_detail_innerwrap" :style="{ width: itemWidth }">
      <div class="detail_imgbox cover">
        <!-- <dsf-image :src="detailData.cover | imgFormat" width="530px" height="280px" /> -->
        <dsf-nc-image :src="detailData.cover | imgFormat" width="530px" height="280px" :error-src="defaultSrc" />
      </div>
      <div class="detail_conent">
        <div class="fixed_button">
          <span @click="handleCollect" :class="{ 'active-item': isCollected }" v-if="showCollect">
            <i class="iconfont icon-shoucang1"></i>
            {{ isCollected ? "已收藏" : "收藏" }}
          </span>
          <span @click="handleShare">
            <i class="iconfont icon-fenxiangfangshi1"></i>
            分享
          </span>
        </div>
        <div class="detail_name ell" :title="detailData.name">{{ detailData.name }}</div>
        <div class="px_date font">培训日期：{{ setDate(detailData.pxsjSdate, detailData.pxsjEdate, "至") }}</div>
        <div class="jytj font">包含内容：{{ detailData.compulsory || 0 }}门必修&nbsp;&nbsp;&nbsp; {{ detailData.electives || 0 }}门选修 &nbsp;&nbsp;&nbsp; {{ totalPeriod }}总学时</div>
        <div class="student font">参与人数：{{ detailData.studentCount }}</div>
        <template v-if="bmsjDate >= 1000">
          <div class="bm_date font">
            距报名开始还剩：
            <span>{{ bmsjDateStr }}</span>
          </div>
        </template>
        <template v-else>
          <div class="bm_date font">报名日期：{{ setDate(detailData.bmsjSdate, detailData.bmsjEdate, "至") }}</div>
        </template>
        <div class="foot_wrap">
          <ul class="labe_wrap">
            <li class="labe_item" v-for="(item, index) in labelLists" :key="index">{{ item }}</li>
          </ul>
          <div class="btn_box">
            <div
              class="btn"
              @click="!isview && clickEnter(detailData)"
              v-if="setStatus(detailData) && isshowbtn && detailData.state != 2"
              :style="`${
                setStatus(detailData) == '待审核' ||
                setStatus(detailData) == '已结业' ||
                setStatus(detailData) == '审核中' ||
                setStatus(detailData) == '已拒绝' ||
                detailData.state == -1 ||
                (detailData.state == 0 && detailData.signStatus != 1) ||
                (detailData.state == 2 && detailData.trainingStatus != 1) ||
                isview
                  ? 'background: #aaa; cursor: default'
                  : ''
              }`"
            >
              {{ setStatus(detailData) }}
            </div>
            <div class="reason" v-if="detailData.state == 5">{{ detailData.reason }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default dsf.component({
  name: "DsfNcPcSpecialDetailNew",
  ctrlCaption: "专题班详情-新",
  mixins: [$mixins.control],
  props: {
    url: {
      type: String,
      default: "/nc/class/info",
    },
    enterStudyUrl: {
      type: Object,
      default: () => ({
        url: `page.html#/pc/nc/pagecourse/coursePlayer?id=@[lastCourseId]&type=ztb`,
      }),
    },
    visible: {
      type: Boolean,
      default: true,
    },
    isshowbtn: {
      type: Boolean,
      default: true,
    },
    itemWidth: {
      type: String,
      default: "1200px",
    },
    showCollect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      detailData: {},
      isCollected: false,
      params: {
        id: "",
      },
      personalInfoUrl: "/nc/class/apply/info",
      labelLists: [],
      defaultSrc: dsf.config.setting_nc_image_default_img,
      clickApplyBtn: false,
      // isShowPersonInforForm: false,
      isview: false,
      bmsjDate: 0,
    };
  },
  created() {
    this.params.id = this.queryString.id || "b9b594f762d241f49189236b0d841c4f";
    this.isview = this.queryString.isview == 1 ? true : false;
  },
  async mounted() {
    if (!this.isDesign) {
      // this.initData();
      await this.specialInfo(this.params);
      this.detailData = this.getSpecialInfo;
      let sDate = new Date(this.detailData ? "" : this.detailData.bmsjSdate.replace(/-/g, "/"));
      let nDate = new Date();
      if (sDate - nDate > 0) {
        this.bmsjDate = sDate - nDate;
        let timer = setInterval(() => {
          if (this.bmsjDate <= 0) {
            window.location.reload();
            clearInterval(timer);
          }
          this.bmsjDate -= 1000;
        }, 1000);
      }

      this.labelLists = this.detailData.labelsText ? this.detailData.labelsText.split("^") : [];
      this.getCollectStatus();
      this.$nextTick(() => {
        this.$page.resize();
      });
    }
  },
  computed: {
    ...mapGetters(["getSpecialInfo", "getSpecialApplyState", "getSpecialApplyInfor"]),
    bmsjDateStr() {
      let days = this.bmsjDate / 1000 / 60 / 60 / 24;
      let daysRound = Math.floor(days);
      let hours = this.bmsjDate / 1000 / 60 / 60 - 24 * daysRound;
      let hoursRound = Math.floor(hours);
      let minutes = this.bmsjDate / 1000 / 60 - 24 * 60 * daysRound - 60 * hoursRound;
      let minutesRound = Math.floor(minutes);
      let seconds = this.bmsjDate / 1000 - 24 * 60 * 60 * daysRound - 60 * 60 * hoursRound - 60 * minutesRound;
      let secondsRound = Math.floor(seconds);
      // console.log("转换时间:", daysRound + "天", hoursRound + "时", minutesRound + "分", seconds + "秒");
      // if (daysRound && daysRound < 10) {
      //   daysRound = "0" + daysRound;
      // }
      if (hoursRound < 10) {
        hoursRound = "0" + hoursRound;
      }
      if (minutesRound < 10) {
        minutesRound = "0" + minutesRound;
      }
      if (secondsRound < 10) {
        secondsRound = "0" + secondsRound;
      }
      let time = daysRound + "天 " + hoursRound + ":" + minutesRound + ":" + secondsRound;
      return time;
    },
    totalPeriod() {
      console.log(floatObj);
      return floatObj.add(Number(this.detailData.compulsoryPeriod || 0), Number(this.detailData.electivesPeriod || 0));
    },
  },
  watch: {
    getSpecialInfo: {
      handler(data) {
        if (data) {
          dsf.layer.closeLoading(this.loading);
          this.detailData = data;
        }
      },
      immediate: true,
    },
    getSpecialApplyState: {
      handler(data) {
        if (data && !this.isDesign) {
          this.specialInfo(this.params);
        }
      },
      immediate: true,
    },
    getSpecialApplyInfor: {
      handler(data) {
        if (data && this.detailData.state == 0 && this.detailData.signStatus == 1 && this.clickApplyBtn) {
          // 未报名且点击报名表单后处理
          if (dsf.isEmptyObject(data.items) || data.items != "[]") {
            this.$openDialog({
              title: "填写个人信息",
              width: "520px",
              height: "auto",
              content: "DsfNcPersonalInformationFormNew",
              params: {
                cb: data => {
                  if (data) {
                    this.specialApply({ id: this.params.id, data });
                  }
                },
              },
              dialogArgs: {},
            });
          } else {
            this.specialApply(this.params);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["specialInfo", "specialApply", "specialApplyInfo"]),
    clickEnter(item) {
      if (!dsf.getToken()) {
        this.$checkLogin().then(res => {
          if (res) next(...params);
        });
        return;
      }
      // console.log("点击按钮", item);
      let status = item.state; // 状态
      let id = item.classId; //专题班id
      let courseId = item.lastCourseId; // 课程id
      let signStatus = item.signStatus; // 1 能报名
      // let trainingStatus = item.trainingStatus; //1能学课
      let url = "";
      if (status == 0 && signStatus == 1) {
        this.loading = dsf.layer.loading();
        this.clickApplyBtn = true; // 申请按钮
        this.specialApplyInfo({ id: this.params.id });
      }
      // else if (status == 2 && trainingStatus == 1) {
      //   let type = item.lastResourceType;

      //   switch (type) {
      //     case "course": // 课程
      //       url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${courseId}&classid=${id}&type=ztb`;
      //       break;
      //     case "video": // 视频
      //       url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${courseId}&classid=${id}&type=ztb`;
      //       break;
      //     case "audio": // 音频
      //       url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${courseId}&classid=${id}&type=ztb`;
      //       break;
      //     case "draft": // 文稿
      //       url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${courseId}&classid=${id}&type=ztb`;
      //       break;
      //     case "media": // 富媒体
      //       url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${courseId}&classid=${id}&type=ztb`;
      //       break;
      //     case "live": // 直播
      //       url = `/page.html#/pc/nc/pagelive/liveDetail?id=${courseId}`;
      //       break;
      //     case "exam": // 考试
      //       this.toExamDetail(item, id);
      //       break;
      //     default:
      //       break;
      //   }
      //   // 进入学习
      //   this.$open({ url, state: 2 });
      // }
    },
    getCollectStatus() {
      this.dsf.http
        .get("/nc/class/getCollectStateCount", { id: this.params.id }, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            this.isCollected = res.data.isCollect == "1";
          } else {
            dsf.layer.message(res.message || "获取数据异常", false);
          }
        })
        .error(err => {
          dsf.layer.message(err.message || "获取数据异常", false);
        })
        .always(function () {});
    },
    toExamDetail(item) {
      const loading = dsf.layer.loading();
      /**
       * @param businessType 专题班1 考核2 单元考试1 任务考试 3
       * @param deviceType pc mobile
       */
      let params = {
        examId: item["lastCourseId"], //考试id
        businessId: item["lastResourceSubId"], //业务id
        businessType: 1,
        deviceType: "pc",
      };
      this.dsf.http
        .get("ncexam/api/getExamUrl", params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            const path = dsf.url.getWebPath(res.data, $$webRoot.exam);
            // window.open(path);
            this.$open({ url: `${location.origin + path}`, state: 2 });
          } else {
            dsf.layer.message(res.message || "获取考试异常", false);
          }
        })
        .error(err => {
          dsf.layer.message(err.message || "获取考试异常", false);
        })
        .always(function () {
          dsf.layer.closeLoading(loading);
        });
    },
    setDate(startDate, endDate, interval) {
      // 设置日期格式
      let start = startDate ? startDate.slice(0, 10) : "";
      let end = endDate ? endDate.slice(0, 10) : "";
      return start && end ? `${start}  ${interval}  ${end}` : "暂无";
    },
    setStatus(data) {
      // 设置状态
      let status = data.state; // 状态
      let studentCount = data.studentCount; // 学员人数
      let sfxzrs = data.txrs; //是否有人数限制
      let html = "";
      switch (status) {
        case -1:
          html = "立即报名";
          break;
        case 0:
          if (sfxzrs && studentCount >= sfxzrs) {
            html = "人数已满";
            return;
          }
          html = "报名";
          break;
        case 1:
          html = "待审核";
          break;
        case 2:
          html = "开始学习";
          break;
        case 3:
          html = "已结业";
          break;
        case 4:
          html = "审核中";
          break;
        case 5:
          html = "已拒绝";
          break;
        default:
          html = "";
      }
      return html;
    },
    handleCollect() {
      this.$checkLogin().then(res => {
        if (res) {
          const sourceUrl = "dsfa/collect/saveOrCancel";
          let params = {
            ywlxValue: "special",
            ywlxText: "专题班",
            ywid: this.params.id,
          };
          commoeLoadPost(
            sourceUrl,
            params,
            ({ message, data }) => {
              dsf.layer.pc.message(message, true);
              this.$set(this, "isCollected", data.isDo);
            },
            err => {
              dsf.layer.pc.message(err.message, false);
            }
          );
        }
      });
    },
    handleShare() {
      function copy(text) {
        if (navigator.clipboard && window.isSecureContext) {
          return navigator.clipboard.writeText(text).then(() => {});
        } else {
          let textArea = document.createElement("textarea");
          textArea.value = text;
          //使textarea不在viewport内，同时设置不可见
          textArea.style.position = "absolute";
          textArea.style.opacity = 0;
          textArea.style.left = "-999999999px";
          textArea.style.top = "-999999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          return new Promise((res, rej) => {
            document.execCommand("copy") ? res() : rej();
            textArea.remove();
          });
        }
      }
      copy(window.location.href).then(() => {
        dsf.layer.message("链接已复制成功！", true);
      });
    },
  },
});

function commoeLoadPost(sourceUrl, params, succFn, failFun, method) {
  // const loading = dsf.layer.pc.loading();
  dsf.http
    .post(sourceUrl, params, $$webRoot.nc)
    .done(res => {
      res.success && succFn && succFn(res);
      if (!res.success) error(res);
    })
    .error(err => {
      error(err);
    })
    .always(res => {
      // dsf.layer.pc.closeLoading(loading);
    });
  function error(err) {
    failFun && failFun(err);
    dsf.layer.pc.message(err.message, false);
  }
}
var floatObj = (function () {
  /*
   * 判断obj是否为一个整数
   */
  function isInteger(obj) {
    return Math.floor(obj) === obj;
  }

  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  function toInteger(floatNum) {
    var ret = { times: 1, num: 0 };
    if (isInteger(floatNum)) {
      ret.num = floatNum;
      return ret;
    }
    var strfi = floatNum + "";
    var dotPos = strfi.indexOf(".");
    var len = strfi.substr(dotPos + 1).length;
    var times = Math.pow(10, len);
    var intNum = Number(floatNum.toString().replace(".", ""));
    ret.times = times;
    ret.num = intNum;
    return ret;
  }

  /*
   * 核心方法，实现加减乘除运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
   *
   * @param a {number} 运算数1
   * @param b {number} 运算数2
   * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
   * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
   *
   */
  function operation(a, b, digits, op) {
    var o1 = toInteger(a);
    var o2 = toInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
      case "add":
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2;
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2);
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2;
        }
        return result / max;
      case "subtract":
        if (t1 === t2) {
          result = n1 - n2;
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2);
        } else {
          result = n1 * (t2 / t1) - n2;
        }
        return result / max;
      case "multiply":
        result = (n1 * n2) / (t1 * t2);
        return result;
      case "divide":
        result = (n1 / n2) * (t2 / t1);
        return result;
    }
  }

  // 加减乘除的四个接口
  function add(a, b, digits) {
    return operation(Number(a), Number(b), digits, "add");
  }
  function subtract(a, b, digits) {
    return operation(Number(a), Number(b), digits, "subtract");
  }
  function multiply(a, b, digits) {
    return operation(Number(a), Number(b), digits, "multiply");
  }
  function divide(a, b, digits) {
    return operation(Number(a), Number(b), digits, "divide");
  }

  // exports
  return {
    add: add,
    subtract: subtract,
    multiply: multiply,
    divide: divide,
  };
})();
</script>
